__turbopack_context__.v({
  "button": "DGcbCG_button",
  "buttonContent": "DGcbCG_buttonContent",
  "container": "DGcbCG_container",
  "icon": "DGcbCG_icon",
  "iconButton": "DGcbCG_iconButton",
  "iconButtonContainer": "DGcbCG_iconButtonContainer",
  "iconContainer": "DGcbCG_iconContainer",
  "list": "DGcbCG_list",
  "option": "DGcbCG_option",
  "withoutBorder": "DGcbCG_withoutBorder",
});
